import { ANALYTICS_ENABLED, ANALYTICS_HOSTNAMES, META_PIXEL_ID } from "../config";

let isInitialized = false;

function canUsePixel() {
  return Boolean(META_PIXEL_ID) &&
    ANALYTICS_ENABLED &&
    typeof window !== "undefined" &&
    ANALYTICS_HOSTNAMES.includes(window.location.hostname.toLowerCase());
}

export function initMetaPixel() {
  if (!canUsePixel() || isInitialized) return;

  /* eslint-disable */
  !(function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)})(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq("init", META_PIXEL_ID);
  isInitialized = true;
}

export function trackMetaPixelEvent(eventName, params) {
  if (!canUsePixel()) return;

  initMetaPixel();
  if (typeof window.fbq === "function") {
    window.fbq("track", eventName, params);
  }
}

export function trackMetaPixelPageView() {
  trackMetaPixelEvent("PageView");
}
